export default __webpack_public_path__ + "static/media/img-04.36b30668.jpg";